import React, { useState, useEffect, useRef } from 'react';
import './Services.css';

function Services() {
  const [visibleCards, setVisibleCards] = useState([]);
  const [hoveredCard, setHoveredCard] = useState(null);
  const sectionRef = useRef(null);

  const services = [
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path d="M35 8.33334H5C3.15906 8.33334 1.66667 9.82573 1.66667 11.6667V28.3333C1.66667 30.1743 3.15906 31.6667 5 31.6667H35C36.8409 31.6667 38.3333 30.1743 38.3333 28.3333V11.6667C38.3333 9.82573 36.8409 8.33334 35 8.33334Z" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M26.6667 25H30" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M18.3333 25H21.6667" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Custom Shopify Design',
      description: 'We create pixel-perfect, custom designs that reflect your brand voice, target audience, and product strategy. Every detail, from typography to animations, is crafted to make a lasting impact.',
      features: ['Brand-aligned visuals', 'Custom UI/UX design', 'Conversion-focused layouts', 'Engaging animations']
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path d="M20 36.6667C29.2048 36.6667 36.6667 29.2048 36.6667 20C36.6667 10.7953 29.2048 3.33334 20 3.33334C10.7953 3.33334 3.33334 10.7953 3.33334 20C3.33334 29.2048 10.7953 36.6667 20 36.6667Z" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M20 13.3333V20L25 22.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Shopify Store Development',
      description: 'Our developers build clean, scalable Shopify themes optimized for speed, usability, and conversions. Each store is fully mobile-friendly, cross-browser tested, and designed for seamless user experience.',
      features: ['Clean, scalable code', 'Mobile-first development', 'Cross-browser compatibility', 'Performance optimized']
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path d="M33.3333 5H6.66666C5.28595 5 4.16666 6.11929 4.16666 7.5V32.5C4.16666 33.8807 5.28595 35 6.66666 35H33.3333C34.714 35 35.8333 33.8807 35.8333 32.5V7.5C35.8333 6.11929 34.714 5 33.3333 5Z" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M26.6667 17.5L20 23.3333L13.3333 17.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Shopify Plus Development',
      description: 'For high-volume businesses, we unlock the full potential of Shopify Plus. From custom checkout flows to ERP and CRM integrations, we scale your ecommerce operations efficiently and securely.',
      features: ['Custom checkout flows', 'ERP & CRM integrations', 'Enterprise scalability', 'Advanced automation']
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path d="M20 3.33334L3.33334 11.6667L20 20L36.6667 11.6667L20 3.33334Z" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M3.33334 28.3333L20 36.6667L36.6667 28.3333" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M3.33334 20L20 28.3333L36.6667 20" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'App Integration & API Work',
      description: 'Need more than Shopify\'s native features? We handle third-party integrations, custom apps, and advanced API development to ensure your store functions exactly as you need.',
      features: ['Third-party integrations', 'Custom app development', 'API connections', 'Workflow automation']
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path d="M13.3333 20C13.3333 23.6819 16.3181 26.6667 20 26.6667C23.6819 26.6667 26.6667 23.6819 26.6667 20C26.6667 16.3181 23.6819 13.3333 20 13.3333C16.3181 13.3333 13.3333 16.3181 13.3333 20Z" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M20 3.33334V8.33334M20 31.6667V36.6667M8.33334 20H3.33334M36.6667 20H31.6667M32.0711 32.0711L28.5355 28.5355M32.0711 7.92893L28.5355 11.4645M7.92893 32.0711L11.4645 28.5355M7.92893 7.92893L11.4645 11.4645" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Migration to Shopify',
      description: 'Switching platforms is seamless with us. We migrate products, content, customers, and orders from WooCommerce, Magento, BigCommerce, or custom systems—without downtime or data loss.',
      features: ['Zero downtime migration', 'Complete data transfer', 'SEO preservation', 'Multi-platform support']
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path d="M35 15H25L21.6667 5H18.3333L15 15H5L13.3333 21.6667L10 31.6667L20 25L30 31.6667L26.6667 21.6667L35 15Z" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Support & Maintenance',
      description: 'Launching is just the start. Our ongoing support covers performance audits, technical maintenance, new feature development, and design updates to help your store grow.',
      features: ['Performance audits', 'Technical maintenance', 'Feature development', 'Design updates']
    }
  ];

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Stagger card entrance animations
            services.forEach((_, index) => {
              setTimeout(() => {
                setVisibleCards((prev) => [...prev, index]);
              }, index * 150);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section id="services" className="services-section" ref={sectionRef}>
      <div className="container">
        <div className="section-header fade-in">
          <div className="section-badge">What We Do</div>
          <h2 className="section-title">
            Services Built for
            <span className="gradient-text"> E&#8209;commerce Success</span>
          </h2>
          <p className="section-description">
            From strategy to execution, we provide end-to-end Shopify solutions
            that help your business thrive in the competitive e-commerce landscape.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div
              key={index}
              className={`service-card ${visibleCards.includes(index) ? 'visible' : ''} ${hoveredCard === index ? 'hovered' : ''}`}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="service-card-background">
                <div className="service-glow"></div>
              </div>

              <div className="service-icon-wrapper">
                <div className="service-icon">{service.icon}</div>
                <div className="icon-particles">
                  <span className="particle particle-1"></span>
                  <span className="particle particle-2"></span>
                  <span className="particle particle-3"></span>
                </div>
              </div>

              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>

              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx} style={{ transitionDelay: `${idx * 0.1}s` }}>
                    <span className="feature-icon">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M13.5 4.5L6 12L2.5 8.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </span>
                    <span className="feature-text">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="services-cta">
          <div className="services-cta-content">
            <h3 className="services-cta-title">Ready to Transform Your Store?</h3>
            <p className="services-cta-subtitle">Let's discuss your project and create a Shopify store that drives real results</p>
          </div>
          <button className="btn-primary btn-large services-cta-btn" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
            <span className="btn-text">Get Started</span>
            <span className="btn-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}

export default Services;
